export const getIsFormsDataFetched = state => state.isDataFetched;

export const getFormIds = state => state.ids;

export const getHasAvailableForms = state => Object.keys(getFormIds(state)).length > 0;

export const findNextForm = (state, measure, measureType) => {
    const key = `${measure}-${measureType}`;
    return getFormIds(state)[key];
};

export const getAttemptNumber = (state, measure, measureType) => {
    const form = findNextForm(state, measure, measureType);
    return form?.attemptNumber;
};
